import { TaxFreeAmount } from 'app/constants/taxFreeAmount'

export const getTaxFreeAmountName = (
  taxFreeAmount: TaxFreeAmount,
  translate: (string) => string,
): string => {
  const text: string = TaxFreeAmount[taxFreeAmount]
  return translate(`taxFreeAmount.${text}`)
}
